export const AUTHENTICATED_HTTP_DEFAULT_ERROR_RESPONSE_MESSAGE = 'There was an error processing your request.';
